// extracted by mini-css-extract-plugin
export default {"ErrorMessage":"_ErrorMessage--Lpwka","ErrorHeader":"_ErrorHeader--toDvw"};